import { Helmet } from 'react-helmet-async';

const Meta = ({
  title = 'Mana Kirana - Kirana & Grocery Delivery',
  description = 'Order groceries and daily essentials online from Mana Kirana with local delivery around Uppalaguptham, Amalapuram and nearby Konaseema areas.',
  keywords = 'Mana Kirana, kirana delivery Uppalaguptham, grocery delivery Amalapuram, online grocery, grocery home delivery',
  canonical,
  image = '/images/logoSquare512_v1.webp',
  type = 'website',
  url,
  jsonLd,
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name='description' content={description} />
      <meta name='keywords' content={keywords} />
      {canonical && <link rel='canonical' href={canonical} />}
      <meta property='og:title' content={title} />
      <meta property='og:description' content={description} />
      <meta property='og:type' content={type} />
      {url && <meta property='og:url' content={url} />}
      <meta property='og:image' content={image} />
      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:title' content={title} />
      <meta name='twitter:description' content={description} />
      <meta name='twitter:image' content={image} />
      {jsonLd && (
        <script type='application/ld+json'>
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export default Meta;
